import { useState } from "react";
import { useSelector } from "react-redux";
import { Badge, Button } from "react-bootstrap";
import { Translate } from "../../../../Enums/Tranlate";
import ConfirmModal from "../../../../common/ConfirmModal";
import BookingRequestsService from "../../../../../services/BookingRequestsService";
import { toast } from "react-toastify";

const CardItem = ({ item, index, setShouldUpdate }) => {
	const [type, setType] = useState("");
	const [sendModal, setSendModal] = useState(false);
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.roles?.includes(data);
	const lang = useSelector((state) => state.auth?.lang);
	const bookingRequestsService = new BookingRequestsService();

	const confirmFunction = () => {
		if (type === "send_email") {
			bookingRequestsService.sendEmail(item?.id).then((res) => {
				if (!!res?.status) {
					toast.success("Email Send Successfully");
					setShouldUpdate((prev) => !prev);
					setSendModal(false);
				}
			});
		} else {
			let data = {
				booking_status: type,
			};
			bookingRequestsService.toggleStatus(item?.id, data).then((res) => {
				if (!!res?.status) {
					toast.success("Status Updated Successfully");
					setShouldUpdate((prev) => !prev);
					setSendModal(false);
				}
			});
		}
	};

	return (
		<tr key={index} className="text-center">
			<td>{item?.id}</td>
			<td className="text-wrap-mode">{item?.court_name || "-"}</td>
			<td className="text-wrap-mode">{item?.date?.split("T")[0] || "-"}</td>
			<td className="text-wrap-mode">{item?.time || "-"}</td>
			<td className="text-wrap-mode">{item?.user_fullname || "-"}</td>
			<td className="text-wrap-mode">{item?.user_phone || "-"}</td>

			<td>
				{item?.booking_status === "pending" ? (
					<div className="d-flex" style={{ gap: "8px" }}>
						<Button
							variant="outline-primary"
							onClick={() => {
								if (isExist("add_booking_requests")) {
									setType("confirmed");
									setSendModal(true);
								}
							}}>
							{Translate[lang].confirm}
						</Button>
						<Button
							variant="outline-secondary"
							onClick={() => {
								if (isExist("delete_booking_requests")) {
									setType("closed");
									setSendModal(true);
								}
							}}>
							{Translate[lang].close}
						</Button>
					</div>
				) : (
					<Badge
						className="text-capitalize"
						variant={`${
							item?.booking_status === "confirmed" ? "success" : "danger"
						} light`}>
						{Translate[lang][item?.booking_status]}
					</Badge>
				)}
			</td>
			<td>
				{item?.booking_status !== "pending" ? (
					<Button
						className="text-wrap-mode"
						variant="outline-primary"
						onClick={() => {
							if (
								isExist("update_booking_requests") ||
								isExist("add_booking_requests")
							) {
								setType("send_email");
								setSendModal(true);
							}
						}}>
						{Translate[lang].send_email}
					</Button>
				) : (
					"-"
				)}
			</td>

			{sendModal && (
				<ConfirmModal
					open={sendModal}
					title={Translate[lang][type]}
					body={
						lang === "en"
							? `are you sure about ${Translate[lang][type]}?`
							: `هل أنت متأكد من ${Translate[lang][type]}`
					}
					button={Translate[lang].submit}
					submitButton={confirmFunction}
					onCloseModal={() => setSendModal(false)}
				/>
			)}
		</tr>
	);
};
export default CardItem;
